import styled from 'styled-components'

interface LeftBarProps {
  variant?: 'primary' | 'secondary';
}

const bgColors = {
  primary: '#52545D',
  secondary: '#475569'
}

export const LeftBar = styled.div<LeftBarProps>`
  background-color: ${props => bgColors[props.variant ?? 'primary']};
  width: 8px;
  min-width: 8px;
  height: 100%;
`